import { render, staticRenderFns } from "./ListFiltroModalItemInputSubProduto.vue?vue&type=template&id=c0af6192"
import script from "./ListFiltroModalItemInputSubProduto.vue?vue&type=script&lang=js"
export * from "./ListFiltroModalItemInputSubProduto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports